export default __webpack_public_path__ + "static/media/coin-1.d8deb809.png";